import { Box, Button, Card, Grid, styled, Typography } from '@mui/material'
import logo from "assets/logo/infoLogo.png";
import telegramLogo from "assets/images/telegram.png"
import telegramQrCode from "assets/images/telegram-qrcode.jpg"

function TelegramCard() {
  return (
    <CardWrapper>
      <Grid container spacing={3}>
        <Grid item xs={12} sm={6}>
          <TelegramInfoWrapper>

          <LogoWrapper>
            <img
              src={logo}
              alt='logo'
            />

            <TelegramLogo
              src={telegramLogo}
              alt='telegram-logo'
            />

          </LogoWrapper>

          <Typography variant='subtitle1' textAlign={"right"} dir="rtl" mt={2}>
            🔹آیا می دانستید با ارزهای دیجیتال ، میتوانید در هر جای دنیا معادل ارز رایج همان کشور ، پول دریافت کنید ؟
            <br />
            🔹کارشناسان ما اینجا هستند تا به شما در زمینه اصول تجارت ارزهای دیجیتال و نحوه تغییر نگرش جهان در امور مالی به شما کمک کنند.
          </Typography>

          <TelegramButton fullWidth LinkComponent={'a'} href='https://t.me/SanaCash' target="_blank">
            SanaCash Telegram
          </TelegramButton>
          </TelegramInfoWrapper>
        </Grid>

        <Grid item xs={12} sm={6}>
          <QrCodeWrapper>
            <img src={telegramQrCode} alt="telegram-qr-code" />
          </QrCodeWrapper>
        </Grid>
      </Grid>
    </CardWrapper>
  )
}

const CardWrapper = styled(Card)(({ theme }) => ({
  background: theme.palette.background.telegramCard,
  color: theme.palette.background.telegramCardColor,
  padding: theme.spacing(3)
}))

const LogoWrapper = styled(Box)(({ theme }) => ({
  borderRadius: "50%",
  border: "10px solid",
  borderColor: theme.palette.background.telegramColor,
  width: "fit-content",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  padding: theme.spacing(3, 4),
  margin: "0 auto",
  boxShadow: theme.shadows[8],
  position: "relative",
  backgroundColor: theme.palette.background.main
}))

const TelegramLogo = styled("img")(({ theme }) => ({
  position: "absolute",
  right: "-20px",
  bottom: "-10px",
  width: "70px",
  height: "auto",
  objectFit: "contain",
  filter: "drop-shadow(0px 2px 6px black)"
}))

const TelegramButton = styled(Button)(({ theme }) => ({
  backgroundColor: theme.palette.background.tradeTypeButtonActive,
  color: theme.palette.background.tradeTypeButtonColor,
  marginTop: theme.spacing(2),

  ":hover": {
    backgroundColor: theme.palette.background.tabButtonHover,
  }
}))

const QrCodeWrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  height: "100%",
  'img': {
    border: "8px solid",
    borderColor: theme.palette.background.telegramQrCodeBorderColor,
    borderRadius: "20px",
    width: "100%",
    height: "auto",
    objectFit: "contain",
    boxShadow: theme.shadows[8]
  }
}))

const TelegramInfoWrapper = styled(Box)(() => ({
  display: "flex",
  justifyContent: "space-between",
  height: "100%",
  flexDirection: "column",
}))

export default TelegramCard